/* Baum-Botschaft: einfacher 4-Schritte-Gestalter auf der Engine (PTGuidedLight) + PayPal Express + Ueberraschungs-Link. ES5. Claude, 23.10.2026 */
(function () {
  "use strict";
  var root = document.getElementById("bb");
  if (!root) return;
  var d = document, w = window;
  var API = "https://partner.planet-tree.de/api2/cert/";
  var FLOW = "geschenk-link-v1";
  function q(s, r) { return (r || root).querySelector(s); }
  function qa(s, r) { return (r || root).querySelectorAll(s); }
  function on(el, ev, fn, o) { if (el && el.addEventListener) el.addEventListener(ev, fn, o || false); }
  function hasCls(el, c) { return el && (" " + el.className + " ").indexOf(" " + c + " ") >= 0; }
  function addCls(el, c) { if (el && !hasCls(el, c)) el.className += " " + c; }
  function rmCls(el, c) { if (el) el.className = (" " + el.className + " ").replace(" " + c + " ", " ").replace(/^\s+|\s+$/g, ""); }
  function retrig(el, c) { if (!el) return; rmCls(el, c); void el.offsetWidth; addCls(el, c); }
  function trim(s) { return String(s || "").replace(/\s+/g, " ").replace(/^\s+|\s+$/g, ""); }
  /* Claude 24.10.2026: nur "Vorname Nachname" aufs erste Wort kuerzen; "Dein Herzensteam", "Oma Gisela", "Familie X", "Anna & Tom" bleiben ganz */
  var KEEP_FULL = /^(dein|deine|deinen|deinem|deiner|euer|eure|euren|eurem|eurer|mein|meine|meinen|meinem|unser|unsere|unseren|unserem|ihr|ihre|die|der|das|den|dem|familie|fam|oma|opa|omi|opi|tante|onkel|mama|papa|mami|papi|mutti|vati|mutter|vater|team|herr|frau|dr|prof|liebe|lieber|liebes|kleine|kleiner|kleines|beste|bester|bestes|alle|kollegen|kollegin|kolleginnen|kollege|schwester|bruder|schwesterherz|patentante|patenonkel|patin|pate|the|mr|mrs|ms|dear|your|our|my|st|sankt|baby|firma)[.,!]?$/i;
  function first(s) { var n = trim(s).slice(0, 40); if (!n || /(\s(und|&|\+)\s)|&|,/.test(n)) return n; var w = n.split(" "); if (w.length < 2) return n; if (KEEP_FULL.test(w[0]) || /\.$/.test(w[0]) || w[0].charAt(0) === w[0].charAt(0).toLowerCase()) return n; return w[0]; }
  function isPl(s) { return /(\s(und|&|\+)\s)|&|,|^(familie|wir|die |eure|euer|team|alle)/i.test(trim(s)); }
  function who(s) { return isPl(s) ? trim(s).slice(0, 40) : first(s); }
  function augen(s) { return "Oh, " + who(s) + (isPl(s) ? " werden" : " wird") + " Augen machen! 😍"; }
  function fmt(n) { n = Math.round(Number(n || 0) * 100) / 100; return (n % 1 ? n.toFixed(2).replace(".", ",") : String(n)) + " €"; }
  function ls(k, v) { try { if (arguments.length > 1) { if (v === null) w.localStorage.removeItem(k); else w.localStorage.setItem(k, v); return v; } return w.localStorage.getItem(k); } catch (e) { return null; } }
  function ss(k, v) { try { if (arguments.length > 1) { w.sessionStorage.setItem(k, v); return v; } return w.sessionStorage.getItem(k); } catch (e) { return null; } }
  function param(k) { var m = new RegExp("[?&]" + k + "=([^&#]*)").exec(location.search); return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : ""; }
  var reduce = false; try { reduce = !!(w.matchMedia && w.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e) {}

  /* TikTok-Klick-ID merken (fuer die Kaufmeldung) */
  var ttclid = param("ttclid") || ss("ptbb_ttclid") || "";
  if (ttclid) ss("ptbb_ttclid", ttclid.slice(0, 300));

  function track(name, data) {
    try { if (w.PTGuidedSession && w.PTGuidedSession.track) w.PTGuidedSession.track(name, data || {}); } catch (e) {}
    try { if (w.dataLayer && w.dataLayer.push) w.dataLayer.push({ event: "ptbb_" + name, ptbb: data || {} }); } catch (e) {}
  }

  var OCC = {
    geburtstag: "Alles Liebe\nzum Geburtstag", weihnachten: "Frohe Weihnachten", danke: "Ein herzliches\nDankeschön",
    liebe: "Für eine Liebe,\ndie wächst", geburt: "Willkommen\nauf der Welt", einfach: "Einfach für dich"
  };
  var FOREST = { by: "Bayerischer Zukunftswald", mv: "Norddeutscher Klimawald", rp: "Eifel-Mischwald" };
  var ui = { step: 1, sender: "", recipient: "", message: OCC.geburtstag, occ: "geburtstag", forest: "by", delivery: "digital", gift: null, trees: 1 };
  try { var dr = JSON.parse(ls("ptbb-v1") || "null"); if (dr && typeof dr === "object") { ["sender", "recipient", "message", "occ", "forest", "trees"].forEach(function (k) { if (dr[k]) ui[k] = dr[k]; }); } } catch (e) {}
  /* Anlass aus dem Link, passend zum TikTok-Video: ?anlass=geburtstag|jahrestag|abschied|hatalles (Claude 23.10.2026) */
  var ANL = {
    geburtstag: { burst: "Kein Geschenk?! \uD83D\uDE31", h1: "Schenk einen <span>echten Baum.</span>", occ: "geburtstag" },
    jahrestag: { burst: "Jahrestag vergessen?! \uD83D\uDE31", h1: "Ein Baum <span>für euch zwei.</span>", sub: "Ein Baum für euch zwei – gepflanzt von Förstern im heimischen Wald. Als Überraschung per WhatsApp, SMS oder E-Mail – in 60 Sekunden.", occ: "liebe" },
    abschied: { burst: "Abschied im Büro? \uD83E\uDD72", h1: "Schenkt einen <span>echten Baum.</span>", sub: "Von allen zusammen: ein echter Baum, gepflanzt von Förstern im heimischen Wald. Als Überraschung per WhatsApp, SMS oder E-Mail – in 60 Sekunden.", occ: "danke", msg: "Danke für alles –\nwir vermissen dich!", from: "z. B. Dein Team" },
    hatalles: { burst: "Hat schon alles? \uD83E\uDD37", h1: "Schenk was, <span>das wächst.</span>", sub: "Etwas, das garantiert noch keiner hat: ein echter Baum, gepflanzt von Förstern im heimischen Wald. Als Überraschung per WhatsApp, SMS oder E-Mail – in 60 Sekunden.", occ: "einfach" }
  };
  var anl = String(param("anlass") || ss("ptbb_anlass") || "").toLowerCase().replace(/[^a-z]/g, "");
  if (ANL[anl]) {
    ss("ptbb_anlass", anl);
    var A = ANL[anl], hEl;
    if ((hEl = d.querySelector(".bb-burst"))) hEl.textContent = A.burst;
    if ((hEl = d.getElementById("bb-h1"))) hEl.innerHTML = A.h1;
    if (A.sub && (hEl = d.querySelector(".bb-sub"))) hEl.textContent = A.sub;
    if (A.from && (hEl = q('[data-bb-field="sender"]'))) hEl.setAttribute("placeholder", A.from);
    if (!(dr && dr.occ)) { ui.occ = A.occ; ui.message = A.msg || OCC[A.occ]; }
    setTimeout(function () { track("landing_anlass", { surface: "bb", anlass: anl }); }, 0);
  }
  /* Beschenkte kommen von der Ueberraschungsseite: 10 % ueber den Shopify-Checkout (Code BAUMWEITER) */
  var gift10 = param("ref") === "fuer-dich" || ss("ptbb_gift10") === "1";
  if (gift10) {
    ss("ptbb_gift10", "1");
    var g10 = q("[data-bb-gift10]"); if (g10) g10.hidden = false;
    addCls(root, "bb--gift10");
    var ck = q("[data-bb-checkout]"); if (ck) ck.textContent = "Zur Kasse – 10 % werden abgezogen (PayPal, Karte, Apple Pay, Klarna) →";
    try { if (w.fetch) w.fetch("/discount/BAUMWEITER", { credentials: "same-origin", redirect: "follow" })["catch"](function () {}); } catch (e) {}
  }
  var saveT = null;
  function saveDraft() { if (saveT) clearTimeout(saveT); saveT = setTimeout(function () { ls("ptbb-v1", JSON.stringify({ sender: ui.sender, recipient: ui.recipient, message: ui.message, occ: ui.occ, forest: ui.forest, trees: ui.trees, delivery: ui.delivery === "gift" ? "digital" : ui.delivery })); }, 400); }

  var L = null;
  var cert = q("[data-bb-cert]"), sayEl = q("[data-bb-say]"), guide = q("[data-bb-guide]"), guideImg = guide ? guide.querySelector("img") : null;
  var IMG = { point: root.getAttribute("data-bb-img-point"), gift: root.getAttribute("data-bb-img-gift"), pphone: root.getAttribute("data-bb-img-pphone") };

  function say(text) { if (!sayEl || sayEl.textContent === text) return; sayEl.textContent = text; if (!reduce) retrig(sayEl, "is-swap"); }
  function guideTo(key) { if (!guideImg || !IMG[key] || guideImg.getAttribute("data-k") === key) return; guideImg.setAttribute("data-k", key); guideImg.src = IMG[key]; if (!reduce) retrig(guide, "is-swap"); }
  function bump() { if (!cert || reduce) return; addCls(cert, "is-bump"); setTimeout(function () { rmCls(cert, "is-bump"); }, 260); }
  function goLive() { if (cert && L && L.stage && L.stage.parentNode === cert) addCls(cert, "is-live"); }

  /* ---------- Felder ---------- */
  var fields = qa("[data-bb-field]");
  var tracked = {};
  function autoVerb() {
    if (!L) return;
    var plural = /(\s(und|&|\+)\s)|&|,|^(familie|wir|die |eure|euer|team|alle|oma und opa|mama und papa)/i.test(trim(ui.sender));
    try { L.verb(plural ? "haben" : "hat"); } catch (e) {}
  }
  for (var fi = 0; fi < fields.length; fi++) (function (inp) {
    var k = inp.getAttribute("data-bb-field");
    inp.value = ui[k] || "";
    on(inp, "input", function () {
      var v = k === "message" ? inp.value.replace(/\r/g, "").slice(0, 70) : inp.value.replace(/[\r\n]+/g, " ");
      ui[k] = v;
      if (L) { try { L.text(k, v); } catch (e) {} if (k === "sender") { autoVerb(); if (ui.photo) photoUI(); } goLive(); }
      if (k === "recipient") { var n = first(v); say(n ? augen(v) : "Tipp einen Namen – und schau aufs Zertifikat! 👀"); }
      if (k === "message" && ui.occ) { ui.occ = ""; syncChips(); }
      if (!tracked[k]) { tracked[k] = 1; track(k === "message" ? "landing_guide_step" : "name_field_started", { surface: "bb", field: k }); }
      saveDraft();
    });
    on(inp, "keydown", function (e) {
      if ((e.keyCode || e.which) !== 13 || k === "message") return;
      e.preventDefault();
      if (k === "recipient") { var s = q('[data-bb-field="sender"]'); if (s && !s.value) { s.focus(); return; } }
      inp.blur(); goStep(2);
    });
  })(fields[fi]);

  /* ---------- Anlass, Wald, Versand, Baeume ---------- */
  function syncChips() {
    var c = qa("[data-bb-occ]"); for (var i = 0; i < c.length; i++) c[i].setAttribute("aria-pressed", c[i].getAttribute("data-bb-occ") === ui.occ ? "true" : "false");
    var f = qa("[data-bb-forest]"); for (var j = 0; j < f.length; j++) f[j].setAttribute("aria-pressed", f[j].getAttribute("data-bb-forest") === ui.forest ? "true" : "false");
    var o = qa("[data-bb-del]"); for (var k = 0; k < o.length; k++) o[k].setAttribute("aria-pressed", o[k].getAttribute("data-bb-del") === ui.delivery ? "true" : "false");
    var t = q("[data-bb-trees]"); if (t) t.textContent = String(ui.trees);
  }
  function setOcc(k) {
    if (!OCC[k]) return;
    ui.occ = k; ui.message = OCC[k];
    var m = q('[data-bb-field="message"]'); if (m) m.value = ui.message;
    if (L) { try { L.text("message", ui.message); } catch (e) {} goLive(); bump(); }
    syncChips(); saveDraft(); track("landing_guide_occasion_selected", { surface: "bb", occasion: k });
  }
  function setForest(k) { if (!FOREST[k]) return; ui.forest = k; if (L) { try { L.forest(k); } catch (e) {} bump(); } syncChips(); saveDraft(); }
  var giftsBox = q("[data-bb-gifts]"), giftsLoaded = false;
  function setDelivery(k) {
    var errEl = q("[data-bb-err]"); if (errEl) errEl.hidden = true;
    if (k === "gift") {
      if (giftsBox) { giftsBox.hidden = false; loadGifts(); }
      say("Such was Kleines aus – der Baum ist dabei! 🎁"); guideTo("gift");
      if (!ui.gift) return;
      ui.delivery = "gift"; syncChips(); prices(); return;
    }
    if (giftsBox) giftsBox.hidden = true;
    var p = Promise.resolve();
    if (L) {
      if (ui.gift) { try { L.removeGift(); } catch (e) {} ui.gift = null; markGift(); }
      p = Promise.resolve(L.delivery(k));
    }
    ui.delivery = k; syncChips(); saveDraft();
    p.then(prices, prices);
  }
  function setTrees(n) { ui.trees = Math.max(1, Math.min(100, n)); if (L) { try { L.trees(ui.trees); } catch (e) {} } syncChips(); prices(); saveDraft(); }
  function markGift() { var g = qa("[data-bb-giftpick]"); for (var i = 0; i < g.length; i++) g[i].setAttribute("aria-pressed", ui.gift && g[i].getAttribute("data-bb-giftpick") === ui.gift.handle ? "true" : "false"); }
  function loadGifts() {
    if (giftsLoaded || !L || !giftsBox) { if (!L && giftsBox) giftsBox.innerHTML = '<p class="bb-gifts-load">Einen Moment …</p>'; return; }
    giftsLoaded = true;
    giftsBox.innerHTML = '<p class="bb-gifts-load">Geschenke werden geladen …</p>';
    Promise.resolve(L.catalog("beliebte-geschenke", 1)).then(function (res) {
      var items = (res && res.items) || [];
      giftsBox.innerHTML = "";
      var n = 0, minP = 0;
      for (var i = 0; i < items.length && n < 6; i++) {
        var it = items[i]; if (!it) continue;
        var v = null; for (var j = 0; j < (it.variants || []).length; j++) if (it.variants[j].available) { v = it.variants[j]; break; }
        if (!v) continue;
        n++; if (!minP || Number(v.price) < minP) minP = Number(v.price);
        var b = d.createElement("button"); b.type = "button"; b.className = "bb-gift";
        b.setAttribute("data-bb-giftpick", it.handle); b.setAttribute("aria-pressed", "false");
        var img = d.createElement("img"); img.alt = ""; img.loading = "lazy";
        var src = (v.image && (v.image.src || v.image)) || it.image || ""; if (typeof src === "object") src = src.src || src.url || "";
        if (src) img.src = String(src).indexOf("cdn.shopify") >= 0 ? String(src).replace(/(\?.*)?$/, function (m) { return (m ? m + "&" : "?") + "width=200"; }) : src;
        var t = d.createElement("span"); t.textContent = String(it.title || "").split(" – ")[0].split(" - ")[0];
        var pr = d.createElement("em"); pr.textContent = fmt(v.price);
        b.appendChild(img); b.appendChild(t); b.appendChild(pr);
        (function (item, variant) {
          on(b, "click", function () {
            try { L.selectGift(item.handle, Number(variant.id)); } catch (e) { showErr(e && e.message); return; }
            ui.gift = { handle: item.handle, title: String(item.title || ""), price: variant.price };
            ui.delivery = "gift"; markGift(); syncChips(); prices(); bump();
            var ge2 = q('[data-bb-del="gift"] em'); if (ge2) ge2.textContent = fmt(variant.price);
            track("gift_selected", { surface: "bb", handle: item.handle });
          });
        })(it, v);
        giftsBox.appendChild(b);
      }
      if (!n) giftsBox.innerHTML = '<p class="bb-gifts-load">Gerade keine Geschenke verfügbar.</p>';
      if (minP) { var ge = q('[data-bb-del="gift"] em'); if (ge && !ui.gift) ge.textContent = "ab " + fmt(minP); }
    }, function () { giftsLoaded = false; giftsBox.innerHTML = '<p class="bb-gifts-load">Geschenke konnten nicht geladen werden.</p>'; });
  }
  function prices() {
    if (!L) return;
    var s = {}; try { s = L.state() || {}; } catch (e) {}
    var pd = q('[data-bb-pr="digital"]'), pp = q('[data-bb-pr="print"]');
    if (pd && s.digital) pd.textContent = fmt(s.digital);
    if (pp && s.print) pp.textContent = fmt(s.print);
    var stk = q(".bb-sticky .bb-next"); if (stk && s.digital) stk.textContent = "🌳 Baum gestalten · ab " + fmt(s.digital);
  }

  /* ---------- Schritte ---------- */
  var steps = qa("[data-bb-step]"), dots = qa(".bb-dots li");
  var SAY = { 1: null, 2: "Ein lieber Satz – und such dir einen Wald aus 🌲", 3: "Noch ein Foto von dir? Kommt in die Überraschung! 📸" };
  var GUIDE = { 1: "point", 2: "point", 3: "gift", 4: "pphone" };
  function showErr(msg) { var e = q("[data-bb-err]"); if (!e) return; e.textContent = msg || "Da ist etwas schiefgelaufen. Bitte versuche es noch einmal."; e.hidden = false; }
  function shake(el) { if (el) retrig(el, "bb-shake"); }
  function goStep(n) {
    if (n > 1 && (!trim(ui.recipient) || !trim(ui.sender))) {
      n = 1;
      var miss = !trim(ui.recipient) ? q('[data-bb-field="recipient"]') : q('[data-bb-field="sender"]');
      shake(miss && miss.parentNode); say(!trim(ui.recipient) ? "Für wen ist der Baum? ✍️" : "Und von wem? ✍️");
      if (ui.step === 1) return;
    }
    ui.step = n;
    for (var i = 0; i < steps.length; i++) { if (steps[i].getAttribute("data-bb-step") === String(n)) addCls(steps[i], "is-on"); else rmCls(steps[i], "is-on"); }
    for (var j = 0; j < dots.length; j++) { rmCls(dots[j], "is-on"); rmCls(dots[j], "is-done"); if (j + 1 < n) addCls(dots[j], "is-done"); else if (j + 1 === n) addCls(dots[j], "is-on"); }
    guideTo(GUIDE[n]);
    if (n === 1) say(trim(ui.recipient) ? augen(ui.recipient) : "Tipp einen Namen – und schau aufs Zertifikat! 👀");
    else if (n === 4) { say("Gleich kriegst du den Link für " + (who(ui.recipient) || "WhatsApp") + "! 💬"); summary(); }
    else say(SAY[n]);
    var b = q("#bb-builder"); if (b) { var r = b.getBoundingClientRect(); if (r.top < 0 || r.top > (w.innerHeight || 700) * 0.4) scrollToEl(b, 8); }
    track(n === 4 ? "landing_guide_complete" : "landing_guide_step", { surface: "bb", step: n });
    if (n === 2 && !tracked.names) { tracked.names = 1; track("name_entered", { surface: "bb" }); }
  }
  function summary() {
    var box = q("[data-bb-sum]"); if (!box) return;
    var s = {}; try { s = L ? L.state() : {}; } catch (e) {}
    var del = "📱 PDF sofort + Überraschungs-Link" + (ui.photo ? " mit Foto" : "");
    var rows = [["Für", trim(ui.recipient)], ["Von", trim(ui.sender)], ["Wald", FOREST[ui.forest]], ["Versand", del]];
    if (ui.trees > 1) rows.push(["Bäume", String(ui.trees)]);
    box.innerHTML = "";
    for (var i = 0; i < rows.length; i++) { var p = d.createElement("p"); var a = d.createElement("span"); a.textContent = rows[i][0]; var b2 = d.createElement("b"); b2.textContent = rows[i][1]; p.appendChild(a); p.appendChild(b2); box.appendChild(p); }
    var t = d.createElement("p"); t.className = "bb-total"; var ta = d.createElement("span"); ta.textContent = "Gesamt"; var tb = d.createElement("b"); tb.textContent = fmt(s.total || 15); t.appendChild(ta); t.appendChild(tb); box.appendChild(t);
    var wv = q("[data-bb-waiver-row]"); if (wv) wv.style.display = ui.delivery === "digital" ? "" : "none";
    var nn = who(ui.recipient), nx = d.querySelectorAll("[data-bb-nx]");
    for (var k = 0; k < nx.length; k++) {
      var dat = nx[k].getAttribute("data-bb-nx") === "dat";
      nx[k].textContent = nn ? nn : (dat ? "der beschenkten Person" : "Die beschenkte Person");
    }
    var nv = q("[data-bb-nxv]"); if (nv) nv.textContent = isPl(ui.recipient) ? "packen das Geschenk aus, sehen den Baum wachsen und bekommen das echte Zertifikat." : "packt das Geschenk aus, sieht den Baum wachsen und bekommt das echte Zertifikat.";
  }

  /* ---------- Foto (optional, erscheint in der Ueberraschung) ---------- */
  ui.photo = null;
  try { var sp0 = w.sessionStorage.getItem("ptbb_photo"); if (sp0 && sp0.indexOf("data:image/jpeg;base64,") === 0) ui.photo = sp0; } catch (e) {}
  var pBox = q("[data-bb-photo-box]"), pIn = q("[data-bb-photo-in]"), pPrev = q("[data-bb-photo-prev]"), pImg = q("[data-bb-photo-img]"), pCap = q("[data-bb-photo-cap]"), pBtn = q("[data-bb-photo-btn]");
  function photoUI() {
    var has = !!ui.photo, n = first(ui.sender);
    if (pPrev) pPrev.hidden = !has;
    if (pBtn) pBtn.style.display = has ? "none" : "";
    if (has && pImg) pImg.src = ui.photo;
    var vn = n ? (/^(dein|deine|euer|eure|mein|meine|unser|unsere|ihr|ihre) /i.test(n) ? n : "von " + n) : "von dir"; /* "von Dein Herzensteam" vermeiden */
    if (pCap) pCap.textContent = vn;
    var stage = q(".bb-stage"), pol = q(".bb-polaroid");
    if (has) {
      if (!pol && stage) { pol = d.createElement("div"); pol.className = "bb-polaroid"; pol.innerHTML = "<img alt=''><span></span>"; stage.appendChild(pol); }
      if (pol) { pol.querySelector("img").src = ui.photo; pol.querySelector("span").textContent = vn; }
    } else if (pol && pol.parentNode) pol.parentNode.removeChild(pol);
  }
  function readPhoto(file) {
    if (!file || !/^image\//.test(file.type || "image/")) { showErr("Bitte ein Bild auswählen."); return; }
    if (file.size > 25 * 1024 * 1024) { showErr("Das Bild ist zu groß (max. 25 MB)."); return; }
    addCls(pBox, "is-busy");
    var url = null, img = new Image();
    function done() { rmCls(pBox, "is-busy"); try { if (url && w.URL) w.URL.revokeObjectURL(url); } catch (e) {} }
    img.onload = function () {
      try {
        var max = 1000, sc = Math.min(1, max / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
        var cw = Math.max(1, Math.round((img.naturalWidth || img.width) * sc)), ch = Math.max(1, Math.round((img.naturalHeight || img.height) * sc));
        var c = d.createElement("canvas"); c.width = cw; c.height = ch;
        var cx = c.getContext("2d"); cx.fillStyle = "#fff"; cx.fillRect(0, 0, cw, ch); cx.drawImage(img, 0, 0, cw, ch);
        ui.photo = c.toDataURL("image/jpeg", 0.85);
        try { w.sessionStorage.setItem("ptbb_photo", ui.photo); } catch (e) {}
        photoUI(); bump(); say("Super Foto! " + (who(ui.recipient) || "Die Person") + (isPl(ui.recipient) ? " werden" : " wird") + " sich freuen 😍");
        track("ptbb_photo_added", {});
      } catch (e) { showErr("Das Bild konnte nicht gelesen werden."); }
      done();
    };
    img.onerror = function () { showErr("Das Bild konnte nicht gelesen werden. Bitte ein JPG oder PNG wählen."); done(); };
    try { url = w.URL.createObjectURL(file); img.src = url; }
    catch (e) { var fr = new FileReader(); fr.onload = function () { img.src = fr.result; }; fr.onerror = img.onerror; fr.readAsDataURL(file); }
  }
  on(pIn, "change", function () { var f = pIn.files && pIn.files[0]; if (f) readPhoto(f); try { pIn.value = ""; } catch (e) {} });
  on(q("[data-bb-photo-del]"), "click", function () { ui.photo = null; try { w.sessionStorage.removeItem("ptbb_photo"); } catch (e) {} photoUI(); });
  function uploadPhoto(bundle) {
    return new Promise(function (res) {
      if (!ui.photo || !bundle) { res(false); return; }
      var x = new XMLHttpRequest(), fin = false;
      function end(ok) { if (!fin) { fin = true; res(ok); } }
      try {
        x.open("POST", API + "bb_photo", true);
        x.setRequestHeader("Content-Type", "application/json");
        x.timeout = 15000;
        x.onreadystatechange = function () { if (x.readyState === 4) end(x.status >= 200 && x.status < 300); };
        x.onerror = function () { end(false); }; x.ontimeout = function () { end(false); };
        x.send(JSON.stringify({ bundle_id: bundle, image: ui.photo }));
      } catch (e) { end(false); }
      setTimeout(function () { end(false); }, 16000);
    });
  }
  photoUI();

  /* ---------- Bezahlen ---------- */
  function loadCheckout() {
    if (w.PTGuidedCheckout) return Promise.resolve(w.PTGuidedCheckout);
    return new Promise(function (res, rej) {
      var src = w.PTGuidedAssets && w.PTGuidedAssets.checkout; if (!src) { rej(new Error("Der Kaufabschluss konnte nicht geladen werden.")); return; }
      var s = d.createElement("script"); s.src = src;
      s.onload = function () { w.PTGuidedCheckout ? res(w.PTGuidedCheckout) : rej(new Error("Der Kaufabschluss konnte nicht geladen werden.")); };
      s.onerror = function () { rej(new Error("Der Kaufabschluss konnte nicht geladen werden. Bitte erneut versuchen.")); };
      d.head.appendChild(s);
    });
  }
  function ttpCookie() { var m = /(?:^|;\s*)_ttp=([^;]+)/.exec(d.cookie || ""); return m ? decodeURIComponent(m[1]).slice(0, 300) : ""; }
  function marketingOk() { try { return !!(w.Shopify && w.Shopify.customerPrivacy && w.Shopify.customerPrivacy.marketingAllowed && w.Shopify.customerPrivacy.marketingAllowed()); } catch (e) { return false; } }
  function safeApprove(u) { try { var x = new URL(u); var h = x.hostname.toLowerCase(); return x.protocol === "https:" && (h === "paypal.com" || h.slice(-11) === ".paypal.com") ? x.href : ""; } catch (e) { return ""; } }
  var paying = false;
  function payPal() {
    if (paying || !L) return;
    var legal = q("[data-bb-legal]"), waiver = q("[data-bb-waiver]");
    var needW = true;
    var lr = q("[data-bb-legal-row]"), wr = q("[data-bb-waiver-row]");
    rmCls(lr, "is-miss"); rmCls(wr, "is-miss");
    if (!legal.checked || (needW && !waiver.checked)) {
      if (!legal.checked) { addCls(lr, "is-miss"); shake(lr); }
      if (needW && !waiver.checked) { addCls(wr, "is-miss"); shake(wr); }
      say("Noch kurz die Häkchen setzen ☝️"); return;
    }
    paying = true;
    var btn = q("[data-bb-paypal]"); addCls(btn, "is-busy"); var old = btn.innerHTML; btn.textContent = "PayPal wird vorbereitet …";
    var errEl = q("[data-bb-err]"); if (errEl) errEl.hidden = true;
    var S = w.PTGuidedSession, prep = null, sid = "";
    track("checkout_click", { payment_method: "paypal", trigger: "bb_express" });
    Promise.resolve(S && S.save ? S.save() : null).then(loadCheckout).then(function (CK) { return CK.prepare(); }).then(function (t) {
      prep = t;
      var ttp = ttpCookie(), mkt = marketingOk();
      var items = (t.items || []).map(function (it) {
        var c = {}, k; for (k in it) if (it.hasOwnProperty(k)) c[k] = it[k];
        if (it.properties && it.properties._pt_role === "base") {
          var p = {}; for (k in it.properties) if (it.properties.hasOwnProperty(k)) p[k] = it.properties[k];
          p._pt_flow = FLOW; p._pt_landing = location.origin + location.pathname;
          if (ttclid) p._pt_ttclid = ttclid; if (ttp) p._pt_ttp = ttp; p._pt_mkt = mkt ? "1" : "0";
          c.properties = p;
        }
        return c;
      });
      sid = S.storage("sessionStorage", "ptq_paypal_session_id");
      if (!/^[A-Za-z0-9_-]{24,96}$/.test(sid || "")) { sid = S.random() + S.random().slice(0, 16); S.storage("sessionStorage", "ptq_paypal_session_id", sid); }
      var o = { session_id: sid, cart_items: items, whatsapp: {}, dhl_wunschtag: "", newsletter_code: "" };
      return S.request(API + "quick_paypal/quote", o).then(function (c) {
        var o2 = {}, k2; for (k2 in o) if (o.hasOwnProperty(k2)) o2[k2] = o[k2];
        o2.quote_token = c.quote_token; o2.legal_ok = true;
        return S.request(API + "quick_paypal/create", o2).then(function (l) { return { c: c, l: l, items: items }; });
      });
    }).then(function (r) {
      var bundle = (r.c && r.c.bundle_id) || (prep && prep.payload && prep.payload.bundle_id);
      return uploadPhoto(bundle).then(function (photoOk) { return { r: r, bundle: bundle, photo: photoOk }; });
    }).then(function (x) {
      var r = x.r, bundle = x.bundle;
      ls("ptbb_last", JSON.stringify({ g: bundle, v: trim(ui.sender), f: trim(ui.recipient), d: "digital", p: x.photo ? 1 : 0, s: (function () { try { return L.state().total; } catch (x) { return 0; } })(), t: Date.now() }));
      if (r.l && r.l.already_paid && bundle) { location.assign("/pages/fuer-dich?g=" + encodeURIComponent(bundle) + "&fertig=1"); return; }
      var url = safeApprove(r.l && r.l.approve_url);
      if (!url) throw new Error("PayPal hat keine sichere Zahlungsadresse zurückgegeben.");
      var pend = JSON.stringify({ bundleId: r.c.bundle_id, session: sid, items: r.items, cartSource: false, createdAt: Date.now(), cleared: false });
      try { w.localStorage.setItem("pt_wurzelbert_cart_paypal_pending_v1", pend); w.sessionStorage.setItem("pt_wurzelbert_cart_paypal_pending_v1", pend); } catch (e) {}
      track("paypal_redirect", { surface: "bb", delivery: ui.delivery });
      location.assign(url);
    })["catch"](function (e) {
      paying = false; rmCls(btn, "is-busy"); btn.innerHTML = old;
      showErr(e && e.message); say("Hm, das hat nicht geklappt 😕");
    });
  }
  /* Claude 24.10.2026: Hauptweg ueber die Shopify-Kasse (Warenkorb -> /checkout), damit TikTok/Meta/Google
     Warenkorb, Kasse und Kauf sehen. Geschenk-Merkmale (_pt_flow ...) wie beim PayPal-Direktweg am Basis-Artikel;
     Danke-Seite (bb_thanks) und Kaeufer-Mail erkennen den Flow daran. */
  function legalOk() {
    var legal = q("[data-bb-legal]"), waiver = q("[data-bb-waiver]");
    var lr = q("[data-bb-legal-row]"), wr = q("[data-bb-waiver-row]");
    rmCls(lr, "is-miss"); rmCls(wr, "is-miss");
    var wOk = !waiver || waiver.checked; /* Claude 26.10.2026: Verzicht-Haekchen entfernt (Leslie) */
    if (!legal) return true; /* AGB-Haekchen entfernt (Leslie): Hinweis steht in der Shopify-Kasse */
    if (legal.checked && wOk) return true;
    if (!legal.checked) { addCls(lr, "is-miss"); shake(lr); }
    if (!wOk) { addCls(wr, "is-miss"); shake(wr); }
    say("Noch kurz die Häkchen setzen ☝️"); return false;
  }
  /* Claude 25.10.2026: kind "paypal" -> gleicher Weg ueber den Warenkorb, dort echter Shopify-PayPal-Express-Knopf (/cart?pt_pay=paypal).
     Der alte PayPal-Direktweg payPal() bleibt im Code, wird aber nicht mehr benutzt (Kaeufe waren fuer die Pixel unsichtbar). */
  function toCheckout(kind) {
    if (paying || !L || !legalOk()) return;
    paying = true;
    var pp = kind === "paypal";
    var a = q(pp ? "[data-bb-paypal]" : "[data-bb-checkout]"), old = a ? a.innerHTML : ""; if (a) { addCls(a, "is-busy"); a.textContent = pp ? "PayPal wird vorbereitet …" : "Kasse wird geöffnet …"; }
    var errEl = q("[data-bb-err]"); if (errEl) errEl.hidden = true;
    var S = w.PTGuidedSession, bundle = "";
    track("checkout_click", { payment_method: pp ? "paypal" : "shopify", trigger: pp ? "bb_paypal_cart" : "bb_checkout" });
    Promise.resolve(S && S.save ? S.save() : null).then(loadCheckout).then(function (CK) { return CK.prepare(); }).then(function (t) {
      bundle = (t.payload && t.payload.bundle_id) || "";
      var ttp = ttpCookie(), mkt = marketingOk();
      var items = (t.items || []).map(function (it) {
        var c = {}, k; for (k in it) if (it.hasOwnProperty(k)) c[k] = it[k];
        if (it.properties && it.properties._pt_role === "base") {
          var p = {}; for (k in it.properties) if (it.properties.hasOwnProperty(k)) p[k] = it.properties[k];
          p._pt_flow = FLOW; p._pt_landing = location.origin + location.pathname;
          if (ttclid) p._pt_ttclid = ttclid; if (ttp) p._pt_ttp = ttp; p._pt_mkt = mkt ? "1" : "0";
          c.properties = p;
        }
        return c;
      });
      return new Promise(function (res, rej) {
        // Doppelklick/zweiter Versuch: gleiche Gestaltung nicht nochmal in den Warenkorb legen
        var g = new XMLHttpRequest();
        g.open("GET", "/cart.js", true);
        g.onreadystatechange = function () {
          if (g.readyState !== 4) return;
          try {
            var cart = JSON.parse(g.responseText || "{}"), has = false;
            (cart.items || []).forEach(function (it) { if (bundle && it.properties && it.properties._pt_bundle_id === bundle) has = true; });
            if (has) { res(); return; }
          } catch (e) {}
          add();
        };
        g.send();
        function add() {
        var x = new XMLHttpRequest();
        x.open("POST", "/cart/add.js", true);
        x.setRequestHeader("Content-Type", "application/json"); x.setRequestHeader("Accept", "application/json");
        x.onreadystatechange = function () { if (x.readyState === 4) { if (x.status >= 200 && x.status < 300) res(); else rej(new Error("Der Warenkorb konnte nicht gefüllt werden. Bitte erneut versuchen.")); } };
        x.onerror = function () { rej(new Error("Keine Verbindung. Bitte erneut versuchen.")); };
        x.send(JSON.stringify({ items: items }));
        }
      });
    }).then(function () { return uploadPhoto(bundle); }).then(function (photoOk) {
      ls("ptbb_last", JSON.stringify({ g: bundle, v: trim(ui.sender), f: trim(ui.recipient), d: "digital", p: photoOk ? 1 : 0, s: (function () { try { return L.state().total; } catch (x) { return 0; } })(), t: Date.now() }));
      track("shopify_checkout_redirect", { surface: "bb", via: pp ? "paypal_cart" : "checkout" });
      var dest = pp ? "/cart?pt_pay=paypal" : "/checkout"; /* Claude 25.10.2026: Herkunft vorher sicher am Warenkorb */
      if (window.ptBeforeCheckout) window.ptBeforeCheckout(function () { location.assign(dest); }); else location.assign(dest);
    })["catch"](function (e) {
      paying = false; if (a) { rmCls(a, "is-busy"); a.innerHTML = old; }
      showErr(e && e.message); say("Hm, das hat nicht geklappt 😕");
    });
  }

  /* ---------- Klicks ---------- */
  on(root, "click", function (e) {
    var t = e.target;
    while (t && t !== root && t.nodeType === 1) {
      if (t.hasAttribute("data-bb-next")) { goStep(ui.step + 1); return; }
      if (t.hasAttribute("data-bb-back")) { goStep(Math.max(1, ui.step - 1)); return; }
      if (t.hasAttribute("data-bb-preview")) { openPreview(); return; }
      if (t.hasAttribute("data-bb-occ")) { setOcc(t.getAttribute("data-bb-occ")); return; }
      if (t.hasAttribute("data-bb-forest")) { setForest(t.getAttribute("data-bb-forest")); return; }
      if (t.hasAttribute("data-bb-del")) { setDelivery(t.getAttribute("data-bb-del")); return; }
      if (t.hasAttribute("data-bb-tree")) { setTrees(ui.trees + Number(t.getAttribute("data-bb-tree"))); return; }
      if (t.hasAttribute("data-bb-paypal")) { toCheckout("paypal"); return; }
      if (t.hasAttribute("data-bb-checkout")) { toCheckout(); return; }
      if (t.hasAttribute("data-bb-play")) { e.preventDefault(); openLb(t.getAttribute("data-bb-play")); return; }
      if (t.hasAttribute("data-bb-totop")) { e.preventDefault(); toBuilder(); return; }
      t = t.parentNode;
    }
  });
  function scrollToEl(el, off) {
    var y = el.getBoundingClientRect().top + (w.pageYOffset || d.documentElement.scrollTop) - (off || 0);
    try { w.scrollTo({ top: y, behavior: reduce ? "auto" : "smooth" }); } catch (e) { w.scrollTo(0, y); }
  }
  function toBuilder() {
    var b = q("#bb-builder"); if (!b) return; scrollToEl(b, 8);
    if (ui.step === 1) setTimeout(function () { var f = !trim(ui.recipient) ? q('[data-bb-field="recipient"]') : !trim(ui.sender) ? q('[data-bb-field="sender"]') : null; if (f) try { f.focus({ preventScroll: true }); } catch (x) { f.focus(); } }, 450);
    track("ptbb_cta", {});
  }

  /* ---------- Video ---------- */
  var lb = d.querySelector("[data-bb-lb]"), big = lb ? lb.querySelector("[data-bb-big]") : null;
  function openLb(src) { if (!lb || !big) return; if (!big.getAttribute("poster") && big.getAttribute("data-poster")) big.setAttribute("poster", big.getAttribute("data-poster")); lb.hidden = false; try { d.documentElement.style.overflow = "hidden"; } catch (e) {} try { big.currentTime = 0; var p = big.play(); if (p && p["catch"]) p["catch"](function () {}); } catch (e) {} track("ptbb_video", { source: src || "" }); }
  function closeLb() { if (!lb || lb.hidden) return; try { big.pause(); } catch (e) {} lb.hidden = true; try { d.documentElement.style.overflow = ""; } catch (e) {} }
  on(lb, "click", function (e) { var t = e.target; if (t === lb) { closeLb(); return; } while (t && t !== lb) { if (t.hasAttribute && t.hasAttribute("data-bb-close")) { closeLb(); if (t.hasAttribute("data-bb-totop")) toBuilder(); return; } t = t.parentNode; } });
  on(d, "keydown", function (e) { if ((e.keyCode || e.which) === 27) closeLb(); });
  var mini = q("[data-bb-mini]");
  function startMini() { setTimeout(function () { var sd = false, et = ""; try { sd = !!(navigator.connection && navigator.connection.saveData); et = String((navigator.connection && navigator.connection.effectiveType) || ""); } catch (e) {} if (sd || /(^|-)(2g|3g)$/.test(et)) return; try { mini.preload = "auto"; mini.muted = true; var p = mini.play(); if (p && p["catch"]) p["catch"](function () {}); } catch (e) {} }, 2500); }
  if (mini && !reduce) { if (d.readyState === "complete") startMini(); else on(w, "load", startMini); }

  /* ---------- Demo (Ueberraschung im Handy), Sticky, Zaehler ---------- */
  var demo = q("[data-bb-demo]"), demoOn = false, sticky = q("[data-bb-sticky]"), builder = q("#bb-builder"), countEl = q("[data-bb-count]"), countOn = false;
  function startDemo() {
    if (demoOn || !demo) return; demoOn = true;
    var sc = { a: q('[data-rv-scr="a"]', demo), b: q('[data-rv-scr="b"]', demo), c: q('[data-rv-scr="c"]', demo) }, box = q("[data-bb-dbox]", demo);
    if (!sc.a || !sc.b || !sc.c || reduce) { if (sc.c) { rmCls(sc.a, "is-on"); addCls(sc.c, "is-on"); } return; }
    function show(k) { for (var key in sc) if (sc.hasOwnProperty(key)) { if (key === k) addCls(sc[key], "is-on"); else rmCls(sc[key], "is-on"); } }
    (function loop() {
      rmCls(box, "is-open"); show("a");
      setTimeout(function () { addCls(box, "is-open"); }, 1800);
      setTimeout(function () { show("b"); }, 2750);
      setTimeout(function () { show("c"); }, 11000);
      setTimeout(loop, 16500);
    })();
  }
  function countUp() {
    if (countOn || !countEl) return; countOn = true;
    var to = Number(countEl.getAttribute("data-bb-count")) || 0, from = Math.max(0, to - 2500), t0 = Date.now();
    function f2(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }
    (function tick() { var k = Math.min(1, (Date.now() - t0) / 1600); countEl.textContent = f2(from + (to - from) * (1 - Math.pow(1 - k, 3))); if (k < 1) setTimeout(tick, 30); })();
  }
  function onScroll() {
    var vh = w.innerHeight || 700;
    if (demo && !demoOn && demo.getBoundingClientRect().top < vh * 1.3) startDemo();
    if (countEl && !countOn && countEl.getBoundingClientRect().top < vh * 0.9) countUp();
    if (sticky && builder) {
      var r = builder.getBoundingClientRect(), hc = q(".bb-herocta"), hr = hc ? hc.getBoundingClientRect() : null;
      var heroSeen = hr && hr.bottom > 0 && hr.top < vh; // Claude 24.10.2026: keine doppelte Leiste, solange der Kaufknopf oben sichtbar ist
      if ((r.bottom < 0 || r.top > vh) && !heroSeen) addCls(sticky, "is-on"); else rmCls(sticky, "is-on");
    }
  }
  on(w, "scroll", onScroll, { passive: true }); on(w, "resize", onScroll); setTimeout(onScroll, 600);

  /* ---------- Engine ---------- */
  function guardUI() {
    if (w.PTGuidedUI && !w.PTGuidedUI.__bb) {
      w.PTGuidedUI.__bb = 1;
      w.PTGuidedUI.restore = function (state) { adopt(state); };
      w.PTGuidedUI.open = function () { toBuilder(); };
    }
  }
  var gTries = 0; (function g() { guardUI(); if (++gTries < 300 && !(w.PTGuidedUI && w.PTGuidedUI.__bb)) setTimeout(g, 50); })();
  function adopt(s) {
    if (!s || typeof s !== "object") return;
    ["sender", "recipient"].forEach(function (k) { if (s[k] && !trim(ui[k])) { ui[k] = String(s[k]); var f = q('[data-bb-field="' + k + '"]'); if (f) f.value = ui[k]; } });
  }
  var booted = false;
  function boot() {
    if (booted || !w.PTGuidedLight) return;
    booted = true; guardUI();
    L = w.PTGuidedLight;
    try { L.init(); } catch (e) {}
    try { L.lang("de"); } catch (e) {}
    try { adopt(L.exportState && L.exportState()); } catch (e) {}
    if (cert && L.stage) cert.appendChild(L.stage);
    try { L.text("sender", ui.sender); L.text("recipient", ui.recipient); L.text("message", ui.message); } catch (e) {}
    autoVerb();
    try { L.forest(ui.forest); L.trees(ui.trees); } catch (e) {}
    try { var st0 = L.state() || {}; if (st0.delivery && st0.delivery !== "digital") { if (st0.gift || st0.giftHandle) { try { L.removeGift(); } catch (x) {} } Promise.resolve(L.delivery("digital")).then(prices, prices); } } catch (e) {}
    try { L.refresh(); } catch (e) {}
    if (trim(ui.sender) || trim(ui.recipient)) setTimeout(goLive, 300);
    syncChips(); prices();
    track("quickview_seen", { surface: "bb" });
  }
  w.PTCustomUIReady = boot;
  on(w, "pt:guided-ready", boot);
  var bt = 0; (function wait() { if (booted) return; if (w.PTGuidedLight) { boot(); return; } if (++bt < 200) setTimeout(wait, 100); })();
  syncChips();
  if (trim(ui.recipient)) say(augen(ui.recipient));
})();

/* Claude 27.10.2026 (Leslie): "Ergebnis ansehen" – echte Ueberraschung (Vorschau-Modus) mit eingegebenen Namen, Wald, Baumzahl und dem Live-Zertifikat */
function openPreview() {
  var d = document, w = window, st = (w.PTBB && w.PTBB.state) ? w.PTBB.state() : null;
  function val(k) { var el = d.querySelector('[data-bb-field="' + k + '"]'); return el ? String(el.value || "").replace(/^\s+|\s+$/g, "") : ""; }
  var to = (st && st.recipient) || val("recipient") || "Paul", from = (st && st.sender) || val("sender") || "";
  var forest = (st && st.forest) || ((d.querySelector('[data-bb-forest][aria-pressed="true"]') || {}).getAttribute ? d.querySelector('[data-bb-forest][aria-pressed="true"]').getAttribute("data-bb-forest") : "by");
  var trees = (st && st.trees) || parseInt((d.querySelector("[data-bb-trees]") || {}).textContent || "1", 10) || 1;
  var u = "/pages/fuer-dich?demo=1&pre=1&phone=1&nofoto=1&f=" + encodeURIComponent(to) + "&v=" + encodeURIComponent(from) + "&wald=" + encodeURIComponent(forest || "by") + (trees > 1 ? "&tn=" + trees : "");
  var im = d.querySelectorAll("[data-bb-cert] img"), i, m;
  for (i = 0; i < im.length; i++) { m = /\/certs\/img\/(PTB-[A-Za-z0-9_-]+\.png)/.exec(im[i].currentSrc || im[i].src || ""); if (m) { u += "&ci=" + encodeURIComponent("/certs/img/" + m[1]); break; } }
  try { if (w.dataLayer) w.dataLayer.push({ event: "bb_preview_open" }); } catch (e) {}
  if (w.ptBbMock && w.PTGuidedLight && w.ptBbMock.openEngine && w.ptBbMock.openEngine(w.PTGuidedLight, { photo: true })) return; /* Claude 27.10.2026: echtes Zertifikat wird gerendert */
  if (w.ptBbMock && w.ptBbMock.open(u + "&bbp=1")) return; /* Claude 26.10.2026: Lightbox statt neuem Tab */
  var win = w.open(u, "_blank"); if (!win) w.location.href = u;
}
